// extracted by mini-css-extract-plugin
module.exports = {"advancedIcon":"add-new-form_advancedIcon__1CRHF"};